import { jsonRpc } from 'communication/src'
import {
  createTemporaryUploadLink,
  createTemporaryDownloadLink,
  deleteTemporarySnapshot,
  createUploadLink,
} from '@/messages'
import useBlob from './useBlob'
import { useMessageStore } from '@/stores/messagesStore'
import i18next from 'i18next'

const t = i18next.t.bind(i18next)
export default function useS3Service() {
  const { blobToBase64 } = useBlob()
  const messageStore = useMessageStore()

  const uploadToS3 = async (uploadLink, data) => {
    const blob = await (await window.fetch(data)).blob()
    await fetch(uploadLink, {
      method: 'PUT',
      headers: {
        'Content-Type': 'image/jpeg',
      },
      body: blob,
    })
  }

  const getTemporarySnapshotUploadLinks = async () => {
    const { uploadLink, thumbnailUploadLink } = await jsonRpc.sendAndWait(createTemporaryUploadLink())
    return { uploadLink, thumbnailUploadLink }
  }

  const saveSnapshot = async data => {
    const { uploadLink, key, bucket } = await jsonRpc.sendAndWait(createUploadLink())
    await uploadToS3(uploadLink, data)
    messageStore.addMessage({
      text: t('meeting.notification.snapshotSaved'),
    })
    return { bucket, key }
  }

  const downloadSnapshot = async thumbnail => {
    const { downloadLink } = await jsonRpc.sendAndWait(createTemporaryDownloadLink(thumbnail))
    const response = await fetch(downloadLink)
    const blob = await response.blob()
    return await blobToBase64(blob)
  }

  const deleteSnapshot = async () => {
    await jsonRpc.sendAndWait(deleteTemporarySnapshot())
  }

  return {
    deleteSnapshot,
    saveSnapshot,
    getTemporarySnapshotUploadLinks,
    uploadToS3,
    downloadSnapshot,
  }
}
